import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { RobotsPolicy } from './Enums'
/**
* Class WebChannelSeoConfig
*  Публичная SEO-конфигурация витрины: значения уровня канала, от которых витрина строит мету, JSON-LD и robots.txt. Секретов в SEO-конфиге нет — маппится 1:1
*/
export class WebChannelSeoConfig extends ActiveModel {

/**
  * organizationName
  * Имя организации для JSON-LD (schema.org Organization) и суффикса `<title>`. <br><br>Если не задано — витрина использует свой публичный домен<br>
  */
  @ActiveField(null)
  organizationName: null | string = null


/**
  * defaultOgImageId
  * Дефолтная og-картинка витрины для страниц без собственного изображения<br>(главная, категории). Domain.Entities.Resources.Resource.Id
  */
  @ActiveField(null)
  defaultOgImageId: null | string = null


  /**
  * robotsPolicy
  * словарь значений публикуется под именем `RobotsPolicy`  *   * Политика индексации витрины: закрывает витрину целиком через robots.txt<br>  *   * - `Indexable` Индексируется  *   * Витрина открыта для индексации (некоммерческие разделы закрыты точечно)  * - `NoindexAll` Закрыта от индексации  *   * Витрина закрыта от индексации целиком (`Disallow: /`) — для тестовых стендов  *   */
  @ActiveField(RobotsPolicy.INDEXABLE)
  robotsPolicy: RobotsPolicy = RobotsPolicy.INDEXABLE
}
